module.exports = __webpack_public_path__ + "static/media/Material-Icons-Regular.0509ab09.woff2";